var React = require('react');

function Info12x12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM5 6V10H7V6H5ZM4.75 3C4.75 2.30964 5.30964 1.75 6 1.75C6.69036 1.75 7.25 2.30964 7.25 3C7.25 3.69036 6.69036 4.25 6 4.25C5.30964 4.25 4.75 3.69036 4.75 3Z","fill":"currentColor"}));
}

Info12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Info12x12;

Info12x12.default = Info12x12;
